import React from "react";
import TaskList from "./taskList";
import UserProfile from "./userProfile";
import "./style.css";
import { useSelector } from "react-redux";
import UsersInfo from "./UsersInfo";

function Home() {
	const userData = useSelector((state) => state.user.data);
	const mbtiDescriptions = {
		INTJ: "معمار: تحلیل‌گر، مستقل و با دید بلندمدت.",
		ENTJ: "رهبر: سازمان‌دهنده، تصمیم‌گیر و استراتژیست.",
		INFJ: "مشاور: بینش‌گرا، ایده‌پرداز و دارای احساس عمیق.",
		ENFJ: "مربی: الهام‌بخش، متقاعدکننده و رهبر طبیعی.",
		ISTJ: "بازرس: منظم، منطقی و وظیفه‌شناس.",
		ESTJ: "مدیر اجرایی: عمل‌گرا، منضبط و قابل اعتماد.",
		ISFJ: "حامی: وفادار، دلسوز و متعهد.",
		ESFJ: "مردمی: اجتماعی، دلسوز و مسئولیت‌پذیر.",
		ISTP: "حرفه‌ای: مستقل، منطقی و کنجکاو.",
		ESTP: "کارآفرین: پرانرژی، واقع‌گرا و عمل‌گرا.",
		ISFP: "هنرمند: منعطف، آرام و خلاق.",
		ESFP: "مجری: خوش‌بین، پرانرژی و اجتماعی.",
		INTP: "فیلسوف: تحلیل‌گر، خلاق و مستقل.",
		ENTP: "مبتکر: متفکر، پرانرژی و بحث‌گر.",
		INFP: "رؤیاپرداز: آرمان‌گرا، خلاق و عمیق.",
		ENFP: "ماجراجو: پرشور، خوش‌بین و الهام‌بخش.",
	};
	return (
		<div className="container vazir home-container">
			{/* UserProfile (Hidden on Mobile/Tablet) */}
			<div className="user-profile-container">
				<UserProfile />
			</div>
			<TaskList />
			<UsersInfo
				user={userData?.user}
				mbti={userData?.user?.mbti}
				mbtiDescriptions={mbtiDescriptions}
				team_users={userData?.team_users}
			/>
		</div>
	);
}

export default Home;
